/** True unless Online Signup Settings explicitly turned signups off. */
export const onlineSignupsEnabled = (settings) =>
  settings?.allowSignups !== false;

/**
 * Public Registration Open and add-to-cart use this map.
 * A missing tournamentSignupSettings row is on (column default).
 * Card payments / Connect is not part of this check.
 */
export const signupOpenByTournamentId = (tournamentIds, rows) => {
  const explicit = new Map(
    (rows || []).map((row) => [
      row.tournamentID,
      onlineSignupsEnabled(row),
    ])
  );
  const map = {};
  (tournamentIds || []).forEach((id) => {
    map[id] = explicit.has(id) ? explicit.get(id) : true;
  });
  return map;
};
